import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CDN_URL}image`
const endpoints = {
    getCaptcha: () => `${RESOURCE_ENDPOINT}/getCaptcha`,
    verifyCaptcha: () => `${RESOURCE_ENDPOINT}/verify-captcha`,
}

export default class ImageApi {
    public getCaptcha = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCaptcha();
        return HttpService.get(url, params, headers, 'absolute');
    }

    public verifyCaptcha = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.verifyCaptcha();
        return HttpService.post(url, payload, params, headers, 'absolute');
    }
}
